import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import UssdItem from './UssdItem';
import { pageTitle, isHome, hasInternet, tabChange } from '../../actions';
import { checkInternet } from '../../utils/checkInternet';
import ContentLoader from "react-content-loader";
import { motion } from "framer-motion";
import _ from 'lodash';
import Footer from '../../components/Footer/Footer';

const spring = {
    type: "spring",
    damping: 60,
    stiffness: 300,
};

const MyLoader = () => (
    <ContentLoader
        height={40}
        rtl={true}
        speed={2}
    >
        <rect x="80%" y="25" rx="3" ry="3" width="60" height="7" />
        <rect x="20" y="25" rx="4" ry="4" width="150" height="7" />
    </ContentLoader>
);

function UssdPage() {
    const dispatch = useDispatch();
    const socket = useSelector(state => state.setSocket);
    const [ussdData, setUssdData] = useState([]);
    const [connected, setConnected] = useState(false);

    useEffect(() => {
        dispatch(isHome(false)); // This is a separate page, so not "Home"
        dispatch(hasInternet(checkInternet()));
        dispatch(pageTitle("کدهای دستوری"));
        dispatch(tabChange("ussd"));

        if (socket) {
            getData(socket);
        }

        // Cleanup listener if needed, but socket.on usually persists. 
        // For strict cleanup we might need socket.off, but in this app structure it seems socket is global.
        // We'll leave it as is to match Home.jsx behavior which doesn't seem to cleanup aggressively.
        
    }, [dispatch, socket]);

    const getData = (socket) => {
        // Listen for data
        socket.on('ussd', data => {
            setUssdData(data);
            setConnected(socket.connected);
        });
        
        // Request data
        socket.emit("ussd", (res) => {
            // Callback if needed
        });
    };

    return (
        <div>
            <div className="mainPage" style={{ paddingTop: '60px', paddingBottom: '60px' }}>
               
                <ul className="price-list ussd">
                    {
                        (connected || ussdData.length > 0) ?
                            _.map(ussdData, (item, index) => {
                                return (
                                    <motion.li
                                        key={index}
                                        layoutTransition={spring}
                                    >
                                        <UssdItem item={item} />
                                    </motion.li>
                                )
                            })
                            :
                            <React.Fragment>
                                {Array.from({ length: 6 }).map((_, i) => (
                                    <li key={i}>
                                        <MyLoader />
                                    </li>
                                ))}
                            </React.Fragment>
                    }
                </ul>
            </div>
            <Footer />
        </div>
    );
}

export default UssdPage;
